import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const HIMYM = () => (
  <StaticQuery
    query={graphql`
      query {
        app: file(relativePath: { eq: "photos/USE HIMYM.png" }) {
          childImageSharp {
            fluid(maxWidth: 700) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => <Img fluid={data.app.childImageSharp.fluid} />}
  />
)

export default HIMYM
